import React from 'react';

import cx from 'classnames';
import dateformat from 'dateformat';
import _ from 'lodash';
import Truncate from 'src/components/truncate';

import { formatTimespent, formatName } from "../../../../services/report.service";

import styles from "../../reports.module.scss";

import DefaultAssetIcon from "../../../../images/defaultAsset.jpg"
import { Col, Row } from 'react-bootstrap';
import entityStyles from "./styles.module.scss";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { localizedStrings } from "../../../../../localization/index"
import Tooltip from 'src/components/tooltip';


class AssetListItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    }

    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;
  }

  render() {
    if (!this.props.item.asset) {
      return false;
    }
    return (
      <a href={`/assets/${this.props.item.asset.id}?source=reports`} target='_blank' className={cx(styles.item, styles.asset, this.props.className)}>
        <img className={styles.icon} src={_.get(this.props.item, 'asset.icon.thumbnail') || DefaultAssetIcon} />
        <div>
          <h5 className={styles.title}><Truncate width={300}  >{_.get(this.props.item, 'asset.name')}</Truncate></h5>
          <ul className={styles.metrics}>
            <li>{_.get(this.props.item, 'analytics.views', 0)} {this.localizedTabsCommons.views}</li>
            <li>{formatTimespent(_.get(this.props.item, 'analytics.avgTimeSpent', 0))} {this.localizedTabsCommons.avg_time}</li>
            {this.props.id === "engagement_assets" ? (
              <li>
                {_.get(this.props.item, "analytics.downloads", 0)} {this.localizedTabsCommons.downloads}
              </li>
            ) : (
              <li>{_.get(this.props.item, "analytics.shares", 0)} {this.localizedTabsCommons.shares}</li>
            )}
          </ul>
          <div className={entityStyles.author}>{this.localizedTabsCommons.author}: {formatName(_.get(this.props.item, 'asset.author', ""))}</div>
        </div>
      </a>
    );
  }
}

class AssetGridItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    }

    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;
  }

  render() {
    return (
      <Row className={styles.row}>
        <Col className={styles.column} md={this.props.id === "engagement_assets" ? 5 : 7}>
          <a href={`/assets/${this.props.item.asset.id}?source=reports`} target='_blank' className={cx(styles.item, styles.asset, this.props.className)}>
            <img className={styles.icon} src={_.get(this.props.item, 'asset.icon.thumbnail') || DefaultAssetIcon} />
            <div className={styles.popularWithYourTeamTitle}>
              <Tooltip content={_.get(this.props.item, 'asset.name')} placement="bottom">
                <h5 className={styles.title}>
                  {_.get(this.props.item, "asset.name")}
                </h5>
              </Tooltip>
              <ul className={cx(styles.metrics, styles.metricsAuthorContainer)}>
                <li>{this.localizedTabsCommons.added}: {dateformat(this.props.item.asset.createdDate, 'dd mmm yyyy')}</li>
                <li>{this.localizedTabsCommons.author}: {formatName(this.props.item.asset.author)}</li>
              </ul>
            </div>
          </a>
        </Col>
        <Col className={styles.column} md={2}>{_.get(this.props.item, 'analytics.views', 0)}</Col>
        <Col className={styles.column} md={2}>{formatTimespent(_.get(this.props.item, 'analytics.avgTimeSpent', 0))}</Col>
        <Col className={styles.column} md={1}>{_.get(this.props.item, 'analytics.shares', 0)}</Col>

        {this.props.id === "engagement_assets" &&
          <Col className={styles.column} md={2}>{_.get(this.props.item, 'analytics.downloads', 0)}</Col>
        }
      </Row>
    );
  }
}

const Asset = {};
Asset.List = AssetListItem;
Asset.Grid = AssetGridItem;


class ShareAssetListItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    }

    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;
  }

  render() {
    if (!this.props.item.asset) {
      return false;
    }

    return (
      <a href={`/assets/${this.props.item.asset.id}?source=reports`} target='_blank' className={cx(styles.item, styles.asset, this.props.className)}>
        <img className={styles.icon} src={_.get(this.props.item, 'asset.icon.thumbnail') || DefaultAssetIcon} />
        <div>
          <h5 className={styles.title}><Truncate  >{_.get(this.props.item, 'asset.name')}</Truncate></h5>
          <ul className={styles.metrics}>
            <li>{_.get(this.props.item, 'analytics.views', 0)} {this.localizedTabsCommons.views}</li>
            <li>{formatTimespent(_.get(this.props.item, 'analytics.avgTimeSpent', 0))} {this.localizedTabsCommons.avg_time}</li>
            <li>{_.get(this.props.item, 'analytics.shares', 0)} {this.localizedTabsCommons.shares}</li>
          </ul>
          <div className={entityStyles.author}>{this.localizedTabsCommons.author}: {formatName(_.get(this.props.item, 'asset.author', ""))}</div>
        </div>
      </a>
    );
  }
}

class ShareAssetGridItem extends React.Component {
  constructor(props) {

    super(props);
    this.state = {

    }

    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;
  }

  render() {
    return (
      <Row className={styles.row}>
        <Col className={styles.column} md={4}>
          <a href={`/assets/${this.props.item.asset.id}?source=reports`} target='_blank' className={cx(styles.item, styles.asset, this.props.className)}>
            <img className={styles.icon} src={_.get(this.props.item, 'asset.icon.thumbnail') || DefaultAssetIcon} />
            <div className={styles.frequentlySharedTitle}>
              <Tooltip content={_.get(this.props.item, 'asset.name')} placement="bottom">
                <h5 className={styles.title}>
                  {_.get(this.props.item, "asset.name")}
                </h5>
              </Tooltip>  <ul className={styles.metrics}>
                <li>{this.localizedTabsCommons.added}: {dateformat(this.props.item.asset.createdDate, 'dd mmm yyyy')}</li>
              </ul>
            </div>
          </a>
        </Col>
        <Col className={styles.column} md={2}><Truncate lines={2}>{formatName(_.get(this.props.item, 'asset.author', ""))}</Truncate></Col>
        <Col className={styles.column} md={2}>{_.get(this.props.item, 'analytics.views', 0)}</Col>
        <Col className={styles.column} md={2}>{formatTimespent(_.get(this.props.item, 'analytics.avgTimeSpent', 0))}</Col>
        <Col className={styles.column} md={1}>{_.get(this.props.item, 'analytics.downloads', 0)}</Col>
        <Col className={styles.column} md={1}>{_.get(this.props.item, 'analytics.shares', 0)}</Col>
      </Row>
    );
  }
}

Asset.Share = {
  List: ShareAssetListItem,
  Grid: ShareAssetGridItem
}

class LeadAssetListItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    }

    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;
  }

  render() {
    if (!this.props.item) {
      return false;
    }

    return (
      <a href={`/assets/${this.props.item.id}?source=reports`} target='_blank' className={cx(styles.item, styles.asset, this.props.className)}>
        <img className={styles.icon} src={_.get(this.props.item, 'icon.thumbnail') || DefaultAssetIcon} />
        <div>
          <h5 className={styles.title}>
            <Truncate width={300}>
              {_.get(this.props.item, 'name')}
            </Truncate>
          </h5>
          <ul className={styles.metrics}>
            <li>{_.get(this.props.item, 'shares', 0)} {this.localizedTabsCommons.interactions}</li>
            <li>{_.get(this.props.item, 'leads', 0)} {this.localizedTabsCommons.leads}</li>
          </ul>
        </div>
      </a>
    );
  }
}

class LeadAssetGridItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    }

    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;
  }

  render() {
    return (
      <Row className={styles.row}>
        <Col className={styles.column} md={6}>
          <a href={`/assets/${this.props.item.id}?source=reports`} target='_blank' className={cx(styles.item, styles.asset, this.props.className)}>
            <img className={styles.icon} src={_.get(this.props.item, 'icon.thumbnail') || DefaultAssetIcon} />
            <div>
              <h5 className={styles.title}>{_.get(this.props.item, 'name')}</h5>
              <ul className={styles.metrics}>
                <li>{this.localizedTabsCommons.added}: {dateformat(this.props.item.createdDate, 'dd mmm yyyy')}</li>
              </ul>
            </div>
          </a>
        </Col>
        <Col className={styles.column} md={2}>{_.get(this.props.item, 'shares', 0)}</Col>
        <Col className={styles.column} md={2}>{_.get(this.props.item, 'leads', 0)}</Col>
      </Row>
    );
  }
}

Asset.Lead = {
  List: LeadAssetListItem,
  Grid: LeadAssetGridItem
}

class DealAssetListItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    }

    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;
  }

  render() {
    if (!this.props.item) {
      return false;
    }

    return (
      <a href={`/assets/${this.props.item.id}?source=reports`} target='_blank' className={cx(styles.item, styles.asset, this.props.className)}>
        <img className={styles.icon} src={_.get(this.props.item, 'icon.thumbnail') || DefaultAssetIcon} />
        <div>
          <h5 className={styles.title}>
            <Truncate width={300}>{_.get(this.props.item, 'name')}</Truncate>
          </h5>
          <ul className={styles.metrics}>
            <li>{_.get(this.props.item, 'shares', 0)} {this.localizedTabsCommons.interactions}</li>
            <li>{_.get(this.props.item, 'opportunities', 0)} {this.localizedTabsCommons.deals}</li>
          </ul>
        </div>
      </a>
    );
  }
}

class DealAssetGridItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    }

    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;
  }

  render() {
    return (
      <Row className={styles.row}>
        <Col className={styles.column} md={6}>
          <a href={`/assets/${this.props.item.id}?source=reports`} target='_blank' className={cx(styles.item, styles.asset, this.props.className)}>
            <img className={styles.icon} src={_.get(this.props.item, 'icon.thumbnail') || DefaultAssetIcon} />
            <div>
              <h5 className={styles.title}>{_.get(this.props.item, 'name')}</h5>
              <ul className={styles.metrics}>
                <li>{this.localizedTabsCommons.added}: {dateformat(this.props.item.createdDate, 'dd mmm yyyy')}</li>
              </ul>
            </div>
          </a>
        </Col>
        <Col className={styles.column} md={2}>{_.get(this.props.item, 'shares', 0)}</Col>
        <Col className={styles.column} md={2}>{_.get(this.props.item, 'opportunities', 0)}</Col>
      </Row>
    );
  }
}

Asset.Deal = {
  List: DealAssetListItem,
  Grid: DealAssetGridItem
}


export default Asset;